import React from "react";

export default function Stack(props) {
  return (
    <div
      className={["Stack", props.className].join(" ")}
      style={{
        gap: props.gap,
      }}
    >
      {props.children}
    </div>
  );
}
